var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',[_c('chat-messages',{attrs:{"profile":_vm.profile,"message-box-ref-id":_vm.messageBoxRefId,"messages":_vm.messages}}),_c('chat-message-box',{attrs:{"message-box":_vm.messagesBox},on:{"submit-text":_vm.handleSubmitText}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }